import { mode } from '@chakra-ui/theme-tools';
export const ButtonStyles = {
  baseStyle: {
    fontWeight: 500,
  },
  sizes: {
    icon: {
      w: '44px',
      h: '44px',
      minW: '44px',
      minH: '44px',
      p: 0,
    },
  },
  variants: {
    primary: {
      bg: 'WPPGreen.300',
      color: 'WPPNavy.300',
      _hover: {
        bg: 'WPPGreen.400',
        _disabled: {
          bg: 'graphite.100',
        },
      },
    },
    secondary: props => ({
      bg: mode('WPPNavy.300', 'WPPNavy.200')(props),
      color: 'white.100',
      _hover: {
        bg: mode('WPPNavy.400', 'WPPNavy.300')(props),
        _disabled: {
          color: 'white.100',
          bg: mode('WPPNavy.400', 'WPPNavy.300')(props),
        },
      },
    }),
    accept: props => ({
      bg: mode('WPPTeal.300', 'WPPTeal.300')(props),
      color: mode('WPPNavy.300', 'WPPNavy.300')(props),
      _hover: {
        bg: mode('WPPTeal.400', 'WPPTeal.400')(props),
        _disabled: {
          bg: 'graphite.100',
        },
      },
    }),
    deny: props => ({
      bg: mode('WPPOrange.300', 'WPPOrange.300')(props),
      color: mode('white', 'white')(props),
      _hover: {
        bg: mode('WPPOrange.400', 'WPPOrange.200')(props),
        _disabled: {
          bg: 'graphite.100',
        },
      },
    }),
    tertiary: props => ({
      bg: mode('graphite.200', 'graphite.500')(props),
      color: mode('graphite.500', 'dark.300')(props),
      _hover: {
        bg: mode('graphite.300', 'graphite.600')(props),
        _disabled: {
          bg: 'graphite.100',
        },
      },
    }),
    send: props => ({
      bg: mode('nexusTeal.100', 'nexusTeal.100')(props),
      color: mode('white', 'white')(props),
      _hover: {
        bg: mode('nexusTeal.200', 'nexusTeal.200')(props),
        _disabled: {
          bg: 'nexusTeal.100',
        },
      },
    }),
    'solid-rounded': {
      bg: 'blueLight',
      color: 'graphite.500',
      borderRadius: 'full',
      _selected: {
        bg: 'campaignStatusGroups.planning',
      },
      _hover: {
        bg: 'campaignStatusGroups.planning',
      },
    },
    blueLight: {
      minWidth: '150px',
      fontSize: 'sm',
      fontWeight: 'semibold',
      background: 'blueLight',
      color: 'graphite.500',
      borderRadius: 'md',
    },
    danger: {
      bg: 'red.500',
      color: 'white.100',
      _hover: {
        bg: 'red.600',
        _disabled: {
          bg: 'graphite.100',
        },
      },
    },
    unstyled: {
      display: 'inline-flex',
      fontWeight: 'bold',
    },
    cancel: {
      bg: 'WPPgray.200',
      color: 'white',
      _hover: {
        bg: 'WPPgray.100',
        _disabled: {
          bg: 'graphite.100',
        },
      },
    },
    icon: {
      bg: 'WPPTeal.300',
      color: 'white',
      borderRadius: 'full',
      _hover: {
        bg: 'WPPTeal.400',
        _disabled: {
          bg: 'graphite.100',
        },
      },
    },
    iconPlain: {
      bg: 'transparent',
      _hover: {
        bg: 'transparent',
      },
      _active: {
        bg: 'transparent',
      },
      _focus: {
        boxShadow: 'none',
      },
    },
  },
  defaultProps: {},
};
